import styled, { css } from 'styled-components';

export const LoaderContainer = styled.div(
  ({ theme }) => css`
    margin: 0 auto 0 auto;
    width: ${theme.sz.s20};
  `,
);

export const Container = styled.div<{ $hasWhiteBackground?: boolean }>(
  ({ theme, $hasWhiteBackground }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: ${theme.co.primary99};
    align-items: center;
    gap: ${theme.sz.s12};
    padding-bottom: ${theme.sz.s18};

    @media (max-width: ${theme.sz.m}) {
      padding-bottom: ${theme.sz.s44};

      gap: 0;
      background-color: ${
        $hasWhiteBackground
          ? /* istanbul ignore next: needs BE data before we can test this */ // TO-DO: uncomment when data is available
            theme.co.neutral99
          : theme.co.primary99
      };
    }
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};
    padding: ${theme.sz.s4};
    max-width: ${theme.sz.lg};
    margin: 0 auto;
    width: 100%;

    @media (max-width: ${theme.sz.m}) {
      padding: 0;
      gap: 0;
    }
  `,
);

export const StickyWrapper = styled.div(
  ({ theme }) => css`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: ${theme.zi.z6};
    padding: ${theme.sz.s4};
    background: ${theme.co.primary98};
    display: flex;
    justify-content: center;
    box-shadow: 0 -${theme.bo.thinWidth} ${theme.sz.s10} rgba(0, 0, 0, 0.08);

    @media (max-width: ${theme.sz.m}) {
      display: block;
    }
  `,
);
